import { render, staticRenderFns } from "./DesignationForm.vue?vue&type=template&id=23f90814&"
import script from "./DesignationForm.vue?vue&type=script&lang=js&"
export * from "./DesignationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports